import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"
import PropTypes from "prop-types";

import { AppContext } from "../../context/AppContext"

import styles from "./NavFooter.module.scss"

const NavFooter = ({ variant = "footer" }) => {
  const { t, i18n } = useTranslation()

  const appContext = useContext(AppContext)
  const { store } = appContext

  const isSidebar = variant === "sidebar";

  return (
    <nav className={`${styles.navFooter} ${isSidebar ? styles.sidebar : styles.footer}`}>
      <NavLink
        to={`/${i18n.language}/${store.initConfig.url}terms-of-use`}
        className={({ isActive }) =>
          isActive && variant === "sidebar" ? styles.active : undefined
        }
      >
        {t("Terms of Use")}
      </NavLink>{" "}
      <span>|</span>
      <NavLink
        to={`/${i18n.language}/${store.initConfig.url}privacy-policy`}
        className={({ isActive }) =>
          isActive && variant === "sidebar" ? styles.active : undefined
        }
      >
        {t("Privacy Policy")}
      </NavLink>{" "}
      <span>|</span>
      <NavLink
        to={`/${i18n.language}/${store.initConfig.url}cookies-policy`}
        className={({ isActive }) =>
          isActive && variant === "sidebar" ? styles.active : undefined
        }
      >
        {t("Cookies Policy")}
      </NavLink>
    </nav>
  )
}

NavFooter.propTypes = {
  variant: PropTypes.oneOf(["footer", "sidebar"]),
};

export default NavFooter
